import { API } from "../axios/API";

export const tipoRetiroService = {
  getTipoRetiro
};

async function getTipoRetiro() {
  // return arrayData;
  try {
    const resp = await API.get("/tipo-retiro");
    
    if (resp.data.length) {
      return resp?.data.map(e => {
        return {
          ...e,
          label: e.nombre,
          value: e.id
        };
      });
    }

    return resp?.data;
  } catch (err) {
    console.log(err);
    return err.response.message;
  }
}